import {
  FEATURE_CREDITS_API_KEYS,
  LICENSE_TYPES,
  SUBSCRIPTIONS_API_KEYS,
} from "features/MySubscriptions/constants/MySubscriptions.constants";
import { useCreditDetails } from "features/MySubscriptions/utils/useCreditDetails";

export const useCheckZoomWebinarActive = () => {
  const {
    data: {
      [FEATURE_CREDITS_API_KEYS.total_credits]: totalCredits,
      [FEATURE_CREDITS_API_KEYS.consumed_credits]: consumedCredits,
    } = {},
  } = useCreditDetails({
    params: {
      [SUBSCRIPTIONS_API_KEYS.feature_key]: LICENSE_TYPES.EXLY_WEBINAR,
    },
  });
  const creditsAvailable = consumedCredits < totalCredits;
  return creditsAvailable;
};
